import React from "react";
import { IconColor } from "../interface/ColorInterface";

export const FaqIconSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => (
  <svg
    width={width || "24"}
    height={height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform={transform}
  >
    <path
      d="M12 2C6.48 2 2 6.03 2 11C2 14.39 4.69 17.36 8.44 18.57L7 22L11.47 19.85C11.81 19.95 12.15 20 12.5 20C17.02 20 21 16.42 21 12C21 7.58 17.02 4 12 4ZM12 18C9.24 18 7 15.76 7 13H9C9 14.66 10.34 16 12 16C13.66 16 15 14.66 15 13C15 11.34 13.66 10 12 10H11V8H13C15.21 8 17 9.79 17 12C17 14.21 15.21 16 13 16H12V18Z"
      fill={color || "white"}
    />
  </svg>
);
